import React from "react";
import { Table } from "antd";
import CustomPagination from "./CustomPagination";

const CustomTable = ({
  columns,
  data,
  pagination,
  loading,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <>
      <CustomPagination
        pagination={pagination}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={false}
        loading={loading}
        bordered
      />
    </>
  );
};

export default CustomTable;
